import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonMarketoFunction } from './button.component.marketo';
import { ButtonSapcdcFunction } from './button.component.cdc';
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent(buttonMarketoFunction, buttonCdcFunction) {
        this.buttonMarketoFunction = buttonMarketoFunction;
        this.buttonCdcFunction = buttonCdcFunction;
        /**
         * When true, the button is rendered as a link.
         * Has a dependency to href.
         */
        this.buttonlink = false;
        /**
         * The url in case of a link button
         */
        this.href = '';
        /**
         * The target, where to open the url link.
         */
        this.target = '';
        /**
         * Noopener & Noreferrer string
         */
        this.rel = '';
        this.buttonClick = new EventEmitter();
        this.classes = {
            lightboxComponent: 'js-m-marketo-lightbox-component',
            sapCdcLightboxComponent: 'js-m-sapcdc-lightbox-component',
        };
    }
    /**
     * Implementation of Angular's OnInit lifecyvle hook
     */
    ButtonComponent.prototype.ngOnInit = function () {
        this.validateInputs();
    };
    /**
     * Validate the input binding properties.
     */
    ButtonComponent.prototype.validateInputs = function () {
        if (this.button) {
            this.modifier = this.button.modifier;
            this.class = this.button.class;
            this.decorator = this.button.decorator;
            this.text = this.button.text;
            this.buttonlink = this.button.buttonlink;
            this.href = this.button.href;
            this.target = this.button.target;
            this.rel = this.button.rel;
            this.disabled = this.button.disabled;
        }
        if (this.button != undefined) {
            this.gated = this.button.gated;
            this.closebuttondisabled = this.button.closebuttondisabled;
            this.campaignId = this.button.campaignId || '';
            this.marketoFlowId = this.button.marketoFlowId || null;
            this.formFlowId = this.button.formFlowId || null;
        }
        // check href
        if (this.buttonlink && !this.href) {
            console.log("ButtonComponent - LinkButton: Validation Warning for href (text: " + this.href + "): No href for <a>");
        }
        this.lightboxComponent = $('html').find("." + this.classes.lightboxComponent);
        this.cdcLightboxComponent = $('html').find("." + this.classes.sapCdcLightboxComponent);
        this.target = this.target || '';
        this.rel = this.rel || '';
    };
    ButtonComponent.prototype.getClass = function () {
        return 'a-button ' + (this.modifier ? 'a-button--' + this.modifier : '') + ' ' + (this.class ? this.class : '');
    };
    ButtonComponent.prototype.getMarketoFlowId = function (gated, marketoflowid) {
        return gated === true && (marketoflowid !== null && marketoflowid !== undefined) ? marketoflowid : null;
    };
    ButtonComponent.prototype.getCdcFlowId = function (gated, formflowid) {
        return gated === true && (formflowid !== null && formflowid !== undefined) ? formflowid : null;
    };
    ButtonComponent.prototype.hasMarketoFlowId = function (gated, marketoflowid) {
        return gated === true && (marketoflowid !== null && marketoflowid !== undefined) ? true : false;
    };
    ButtonComponent.prototype.hasCdcFlowId = function (gated, formflowid) {
        return gated === true && (formflowid !== null && formflowid !== undefined) ? true : false;
    };
    ButtonComponent.prototype.getCampaignId = function (campaignId) {
        return campaignId !== undefined ? campaignId : null;
    };
    ButtonComponent.prototype.IsCloseButtonDisabled = function (closebuttondisabled) {
        return closebuttondisabled !== undefined ? closebuttondisabled : false;
    };
    ButtonComponent.prototype.onClick = function (e) {
        if (this.disabled) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
        if (this.emitEvent === true) {
            this.buttonClick.emit();
        }
        if ($(".o-product-finderv2__config").length > 0) {
            // const $target = $(e.target).attr("href");
            // e.preventDefault();
            // this.handleDownloadFile($target);
        }
    };
    ButtonComponent.prototype.handleDownloadFile = function (fileUrl) {
        fetch(fileUrl)
            .then(function (response) { return response.blob(); })
            .then(function (blob) {
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileUrl.split("/").pop();
            document.body.appendChild(link);
            link.click();
            // Clean up by revoking the object URL and removing the link element
            setTimeout(function () {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);
        })
            .catch(function (error) {
            console.error('Error downloading the PDF:', error);
        });
    };
    /**
     * Event - Fires after click on the button or link.
     * If disabled, the click event will prevent the default behavior and
     * stop event bubbling.
     * @param e
     */
    ButtonComponent.prototype.btnDownloadClicked = function (e) {
        if (this.disabled) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
        var $target = $(e.target).attr('href');
        var $targetClasses = $(e.target).attr('class');
        if ($target != undefined && $target.indexOf('/api/tds') == -1
            && $targetClasses != undefined && $targetClasses.indexOf("js-m-download-item__button-download") > -1) {
            if ($('.o-product-finderv2__config').length > 0) {
                e.preventDefault();
                this.buttonMarketoFunction.onDownloadBtnClicked(e, this.lightboxComponent);
            }
        }
        if (this.emitEvent === true) {
            this.buttonClick.emit();
        }
    };
    ButtonComponent.prototype.btnCdcDownloadClicked = function (e) {
        if (this.disabled) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
        var $target = $(e.target).attr('href');
        var $targetClasses = $(e.target).attr('class');
        if ($target != undefined && $targetClasses != undefined
            && $target.indexOf('/api/tds') == -1
            && $targetClasses.indexOf("js-m-download-item__button-download") > -1) {
            if ($('.o-product-finderv2__config').length > 0) {
                e.preventDefault();
                this.buttonCdcFunction.onDownloadBtnClicked(e, this.cdcLightboxComponent);
            }
        }
        if (this.emitEvent === true) {
            this.buttonClick.emit();
        }
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-button',
                    template: "<ng-template [ngIf]=\"hasMarketoFlowId(gated, marketoFlowId)\" [ngIfElse]=\"elseContent\">\r\n\t<button *ngIf=\"!buttonlink; else link\" [ngClass]=\"getClass()\" [innerHTML]=\"text\" data-t-name=\"Button\"\r\n\t  [attr.data-t-decorator]=\"decorator\" [disabled]=\"disabled\"\r\n\t  [attr.data-mktoflow-id]=\"getMarketoFlowId(gated, marketoFlowId)\"\r\n\t  [attr.data-mktocampaign-id]=\"getCampaignId(campaignId)\"\r\n\t  [attr.data-mktoflow-close-disabled]=\"IsCloseButtonDisabled(closebuttondisabled)\"\r\n\t  (click)=\"btnDownloadClicked($event)\"></button>\r\n\t<ng-template #link>\r\n\t  <a [ngClass]=\"getClass()\" [href]=\"href\" [target]=\"target\" [rel]=\"rel\" [innerHTML]=\"text\" data-t-name=\"Button\"\r\n\t\t[attr.data-t-decorator]=\"decorator\" [attr.data-mktoflow-id]=\"getMarketoFlowId(gated, marketoFlowId)\"\r\n\t\t[attr.data-mktocampaign-id]=\"getCampaignId(campaignId)\"\r\n\t\t[attr.data-mktoflow-close-disabled]=\"IsCloseButtonDisabled(closebuttondisabled)\"\r\n\t\t(click)=\"btnDownloadClicked($event)\"></a>\r\n\t</ng-template>\r\n  </ng-template>\r\n\r\n  <ng-template #elseContent>\r\n\t<ng-container *ngIf=\"hasCdcFlowId(gated, formFlowId); else elseContent1\">\r\n\t  <button *ngIf=\"!buttonlink; else linkCdc\" [ngClass]=\"getClass()\" [innerHTML]=\"text\" data-t-name=\"Button\"\r\n\t\t[attr.data-t-decorator]=\"decorator\" [disabled]=\"disabled\"\r\n\t\t[attr.data-formflow-id]=\"getCdcFlowId(gated, formFlowId)\"\r\n\t\t[attr.data-formcampaign-id]=\"getCampaignId(campaignId)\"\r\n\t\t[attr.data-formflow-close-disabled]=\"IsCloseButtonDisabled(closebuttondisabled)\"\r\n\t\t(click)=\"btnCdcDownloadClicked($event)\"></button>\r\n\t  <ng-template #linkCdc>\r\n\t\t<a [ngClass]=\"getClass()\" [href]=\"href\" [target]=\"target\" [rel]=\"rel\" [innerHTML]=\"text\" data-t-name=\"Button\"\r\n\t\t  [attr.data-t-decorator]=\"decorator\" [attr.data-formflow-id]=\"getCdcFlowId(gated, formFlowId)\"\r\n\t\t  [attr.data-formcampaign-id]=\"getCampaignId(campaignId)\"\r\n\t\t  [attr.data-formflow-close-disabled]=\"IsCloseButtonDisabled(closebuttondisabled)\"\r\n\t\t  (click)=\"btnCdcDownloadClicked($event)\"></a>\r\n\t  </ng-template>\r\n\t</ng-container>\r\n  </ng-template>\r\n\r\n  <ng-template #elseContent1>\r\n\t<button *ngIf=\"!buttonlink; else linkFallback\" [ngClass]=\"getClass()\" [innerHTML]=\"text\" data-t-name=\"Button\"\r\n\t  [attr.data-t-decorator]=\"decorator\" [disabled]=\"disabled\" (click)=\"onClick($event)\"></button>\r\n\t<ng-template #linkFallback>\r\n\t  <a [ngClass]=\"getClass()\" [href]=\"href\" [target]=\"target\" [rel]=\"rel\" [innerHTML]=\"text\" data-t-name=\"Button\"\r\n\t\t[attr.data-t-decorator]=\"decorator\" (click)=\"onClick($event)\"></a>\r\n\t</ng-template>\r\n  </ng-template>\r\n"
                }] }
    ];
    /** @nocollapse */
    ButtonComponent.ctorParameters = function () { return [
        { type: ButtonMarketoFunction },
        { type: ButtonSapcdcFunction }
    ]; };
    ButtonComponent.propDecorators = {
        button: [{ type: Input }],
        modifier: [{ type: Input }],
        class: [{ type: Input }],
        decorator: [{ type: Input }],
        text: [{ type: Input }],
        buttonlink: [{ type: Input }],
        href: [{ type: Input }],
        target: [{ type: Input }],
        rel: [{ type: Input }],
        gated: [{ type: Input }],
        campaignId: [{ type: Input }],
        closebuttondisabled: [{ type: Input }],
        marketoFlowId: [{ type: Input }],
        formFlowId: [{ type: Input }],
        disabled: [{ type: Input }],
        emitEvent: [{ type: Input }],
        buttonClick: [{ type: Output }]
    };
    return ButtonComponent;
}());
export { ButtonComponent };
//# sourceMappingURL=button.component.js.map